import React, { useState, useRef, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFetchingCustomerBookings } from "redux/actions/customerInfo.actions";
import {
  getCustomerNoShowBookings,
  getCustomerTotalBookings,
  getCustomerUpcomingBookings,
} from "services/booking.service";

/**
 *
 * @param {number} customerId
 */
const useCustomerBookingsInfo = (customerId, runOnLoad = true) => {
  const dispatch = useDispatch();

  const refreshData = () => {
    if (!customerId) return;
    dispatch(setFetchingCustomerBookings(true));
    Promise.all([
      dispatch(getCustomerTotalBookings(customerId)),
      dispatch(getCustomerUpcomingBookings(customerId)),
      dispatch(getCustomerNoShowBookings(customerId)),
    ]).finally(() => {
      dispatch(setFetchingCustomerBookings(false));
    });
  };

  useEffect(() => {
    if (runOnLoad) refreshData();
  }, [runOnLoad, customerId]);

  return refreshData;
};

export default useCustomerBookingsInfo;
